export enum AuditReportStatuses {
    startProgress = "START_PROGRESS",
    underEvaluation = "UNDER_EVALUATION",
    confirmFindings = "CONFIRM_FINDINGS",
    inProgress = "IN_PROGRESS",
    closed = "CLOSED",
    cancelled = "CANCELLED",
    underReview = "UNDER_REVIEW",
}

export enum AuditReportStatusMapping {
    "START_PROGRESS" = "Start Progress",
    "UNDER_EVALUATION" = "Under Evaluation",
    "CONFIRM_FINDINGS" = "Confirm Findings",
    "IN_PROGRESS" = "In Progress",
    "CLOSED" = "Closed",
    "CANCELLED" = "Cancelled",
    "UNDER_REVIEW" = "UNDER REVIEW",
}

export enum AuditReportStatusMappingAr {
    "START_PROGRESS" = "بدء التدقيق",
    "UNDER_EVALUATION" = "قيد التقييم",
    "CONFIRM_FINDINGS" = "تأكيد النتائج",
    "IN_PROGRESS" = "قيد الاجراء",
    "CLOSED" = "مغلق",
    "CANCELLED" = "ملغى",
    "UNDER_REVIEW" = "تحت الملاحظة",

}